// /**
//  * Updates the recently viewed products in localStorage.
//  */
// export class RecentlyViewed {
//   /** @static @constant {string} The key used to store the viewed products in session storage */
//   static #STORAGE_KEY = 'viewedProducts';
//   /** @static @constant {number} The maximum number of products to store */
//   static #MAX_PRODUCTS = 4;

//   /**
//    * Adds a product to the recently viewed products list.
//    * @param {string} productId - The ID of the product to add.
//    */
//   static addProduct(productId) {
//     let viewedProducts = this.getProducts();

//     viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
//     viewedProducts.unshift(productId);
//     viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

//     localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
//   }

//   static clearProducts() {
//     localStorage.removeItem(this.#STORAGE_KEY);
//   }

//   /**
//    * Retrieves the list of recently viewed products from session storage.
//    * @returns {string[]} The list of viewed products.
//    */
//   static getProducts() {
//     return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
//   }
// }















export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 10;

  static addProduct(productId) {
    if (!productId) return;
    let viewedProducts = this.getProducts();
    viewedProducts = viewedProducts.filter(id => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);
    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  static async renderProducts(containerSelector) {
  const container = document.querySelector(containerSelector);
  const ids = this.getProducts();

  if (!container || ids.length === 0) {
    container?.closest('.recently-viewed-product')?.style.setProperty('display', 'none');
    return;
  }

  const query = ids.map(id => `id:${id}`).join(' OR ');
  const searchUrl = `/search?type=product&q=${encodeURIComponent(query)}`;

  try {
    const res = await fetch(searchUrl);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const cards = doc.querySelectorAll(
      'li.grid__item, li.product-grid__item'
    );
    if (!cards.length) return;
    container.innerHTML = '';
    cards.forEach((card, index) => {
      if (index >= 10) return;
      const inner = card.innerHTML;
      const slide = document.createElement('div');
      slide.className = 'swiper-slide recently-viewed-slide';
      slide.innerHTML = inner;

      container.appendChild(slide);
    });
    container.dispatchEvent(new CustomEvent('recentlyViewed:loaded'));

  } catch (e) {
    console.error('Recently Viewed Error:', e);
  }
}
}

window.RecentlyViewed = RecentlyViewed; 

